import { PacketOut } from "./PacketOut.js";
import { OutboundPacketType } from "./OutboundPacketType.js";
import type { MessageIOContext } from "../../../api/MessageIOContext.js";
import type { Tile } from "../../../../royalur/model/Tile.js";


export class PacketOutMove extends PacketOut {
    public static readonly SOURCE_TILE_KEY = "source_tile";

    private readonly sourceTile: Tile | null;

    constructor(sourceTile: Tile | null) {
        super(OutboundPacketType.MOVE);
        this.sourceTile = sourceTile;
    }

    override writeContents(_context: MessageIOContext): Record<string, any> {
        return {
            [PacketOutMove.SOURCE_TILE_KEY]: (this.sourceTile?.toString() ?? null),
        };
    }
}
